import React, { useEffect, useRef, useState } from 'react'
import { encryptStr } from '@yuanfudao/metis-unified-login'
import { resetPassWord } from '@yuanfudao/metis-unified-login/es/service/login'
import VerifyPhone from './verify-phone'
import SetPassword from './set-password'
import lessModule from './index.module.less'

interface ForgotPasswordProps {
  onSuccess: () => void
  onCancel: () => void
}

interface PhoneVerification {
  phone: string
  verification: string
}

function encrypt(value: string) {
  const encrypted = encryptStr(value)
  if (!encrypted) throw new Error('加密失败，请刷新页面重试')
  return encrypted
}

export default function ForgotPassword({ onSuccess, onCancel }: ForgotPasswordProps) {
  const [credentials, setCredentials] = useState<PhoneVerification>()
  const [step, setStep] = useState<'phone' | 'password'>('phone')
  const [retryAt, setRetryAt] = useState(0)
  const mounted = useRef(true)
  useEffect(() => {
    mounted.current = true
    return () => { mounted.current = false }
  }, [])

  const submitPassword = async (password: string) => {
    if (!credentials) throw new Error('请先输入手机号和验证码')
    // 保留原接口：服务端在最终改密时一起校验手机号、验证码和新密码。
    const { data: { code, message } } = await resetPassWord({
      phone: encrypt(credentials.phone),
      verification: encrypt(credentials.verification),
      password: encrypt(password),
    })
    if (!mounted.current) return
    if (code !== '0') throw new Error(message || '密码设置失败，请稍后重试')
    setCredentials(undefined)
    onSuccess()
  }

  return (
    <main className={lessModule.main}>
      {step === 'phone' ? (
        <VerifyPhone
          initialPhone={credentials?.phone}
          retryAt={retryAt}
          onCodeSent={setRetryAt}
          onNext={async (phone, verification) => {
            setCredentials({ phone, verification })
            setStep('password')
          }}
          onCancel={onCancel}
        />
      ) : (
        <SetPassword
          onSubmit={submitPassword}
          onCancel={() => setStep('phone')}
        />
      )}
    </main>
  )
}
